<!-- 订单价格明细 列表 -->
<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      :close-on-popstate="true"
      :overlay-style="{bottom: bottom+'px',height:'auto'}"
      class="box"
      :style="{bottom: bottom+'px'}"
    >
      <van-cell-group>
        <van-cell :title="title" />
        <div
          v-for="(info,index1) in priceList"
          :key="index1"
        >
          <van-cell
            :title="info.name"
            :class="info.class"
            :style="info.style"
            v-if="info.type !== 'spliter'"
            v-show="info.show||info.show==undefined"
          >
            <span
              v-show="!info.hideYen"
              class="font12 money-color"
            >&yen;</span>
            <span class="red">{{ info.price==-1 ? '待核算' : info.price }}</span>
            <span
              class="font12"
              v-show="info.amount"
            >
              ×{{ info.amount }}{{ info.unit }}
            </span>
          </van-cell>
          <van-cell
            v-else
            v-show="info.show||info.show==undefined"
          >
            <div class="spliter">
              {{ info.name }}
            </div>
          </van-cell>
        </div>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import { CellGroup, Cell, Popup } from 'vant'

export default {
  name: 'PriceDetail',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    [CellGroup.name]: CellGroup,
    // eslint-disable-next-line vue/no-unused-components
    [Cell.name]: Cell,
    // eslint-disable-next-line vue/no-unused-components
    [Popup.name]: Popup,
  },
  props: {
    title: {
      type: String,
      default: '订单价格明细',
    },
    priceList: {
      type: [Array, Object],
      default: function () {
        return [
          // { name: '儿童', price: cache.chdFcny, amount: this.tkSearchInfo.childNum, unit: '人' ,show:this.tkSearchInfo.childNum>0?true:false},
          /*
           * name: 左侧名称
           * price 价格
           * amount 数量（数量为0时 数量 单位 都不显示）
           * unit 单位名称
           * show 默认显示 可不传  //动态控制显示隐藏  //可传参数  false不显示  true 显示
           */
        ]
      },
    },
    bottom: {
      //底部导航栏的高度
      type: String,
      default: '50',
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  methods: {
    toggle() {
      this.isShow = !this.isShow
    },
  },
}
</script>

<style  lang="less" scoped>
.box {
  padding-bottom: 4px;
}
.spliter {
  display: flex;
  justify-content: center;
  color: #999093 !important;
}
</style>
